import React from "react";
import style from "./index.module.scss";
import CardInfo from "./components/CardInfo";
interface GeneralProps {
    sessionsNum: number; // 累计直播次数
    playbackNum: number; // 累计回放次数
    avgLiveUV: number; //在线平均人数
    avgDuration: number; //直播平均时长
    avgTotalPlayDuration: number; //观看平均时长
    avgPlaybackPV: number; //回看平均次数
    avgPlaybackUV: number; //回看平均人数
}

export default function General({
    sessionsNum,
    playbackNum,
    avgLiveUV,
    avgDuration,
    avgTotalPlayDuration,
    avgPlaybackPV,
    avgPlaybackUV
}: GeneralProps) {
    const liveCount = {
        icon: require("./img/liveCount.png"),
        bgImg: require("./img/live.png"),
        name: "累计直播次数",
        count: sessionsNum,
        others: [
            {
                name: "在线平均⼈数",
                count: avgLiveUV,
                unit: "人"
            },
            {
                name: "直播平均时⻓",
                count: avgDuration,
                unit: "分钟"
            },
            {
                name: "观看平均时⻓",
                count: avgTotalPlayDuration,
                unit: "分钟"
            }
        ]
    };
    const backCount = {
        icon: require("./img/backCount.png"),
        bgImg: require("./img/back.png"),
        name: "累计回放次数",
        count: playbackNum,
        others: [
            {
                name: "回看平均人数",
                count: avgPlaybackUV,
                unit: "人"
            },
            {
                name: "回看平均次数",
                count: avgPlaybackPV,
                unit: "次"
            }
        ]
    };

    return (
        <div className={style.general}>
            <CardInfo {...liveCount} />
            <CardInfo {...backCount} />
        </div>
    );
}
